const MAGIC_LINK_LANDING_STEP = Object.freeze({
  LANDING_STEP: "LANDING_STEP",
  CONFIRMATION_STEP: "CONFIRMATION_STEP",
});

export { MAGIC_LINK_LANDING_STEP };
